/*--------------------------------------------------------------
# Custom scripts for Testimonial block
--------------------------------------------------------------*/

const testiSlider = document.querySelectorAll('.testimonial .swiper');
const testiSliderNext = document.querySelectorAll('.testi-swiper-next');
const testiSliderPrev = document.querySelectorAll('.testi-swiper-prev');

for( i = 0; i < testiSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    testiSlider[i].classList.add('swiper-' + i);
    testiSliderNext[i].classList.add('testi-swiper-next-' + i);
    testiSliderPrev[i].classList.add('testi-swiper-prev-' + i);

    var initTestiSlider = new Swiper('.testimonial .swiper-' + i, {
        simulateTouch: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        loop: false,
        // Navigation arrows
        navigation: {
            nextEl: '.testi-swiper-next-' + i,
            prevEl: '.testi-swiper-prev-' + i,
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
                slidesPerGroup: 1, // how many to slide at a time
            },
        }
    });
}
